import React, { PropsWithChildren } from 'react'

export const LineChartSVGWrapper = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<any>
>(({ children, ...rest }, ref) => {
  return (
    <div
      key="svg-wrapper"
      ref={ref}
      css={{
        position: 'relative',
        verticalAlign: 'top',
        overflow: 'hidden',
        width: '100%'
      }}
      {...rest}
    >
      {children}
    </div>
  )
})

LineChartSVGWrapper.displayName = 'LineChartSVGWrapper'
